import HttpRequest from './axios'
const request = new HttpRequest()
// import qs from 'qs'
/**
 * 获取类目
 */
export const getCategoryList = () => request.post('/category/list')
// 门店申请审核
export const postAppStoreData = (data) => request.post('','api/store-apply/sumbit-store',data)
// 获取门店申请信息
export const poststoreApplyGetStoreApplyInfo = (data) =>request.post('','store-apply/get-store-apply-info',data)
// 提交会务报名下一步
export const postBaomingDetails = (data) => request.get('','api/meet/bao-ming/get-from',data)
// 校验推荐人
export const postCheckRemoblie = (data) => request.post('','api/meet/bao-ming/check-remobile',data)
// 报名详情
export const getBaomingDetails = (data) => request.get('','api/meet/bao-ming/get-my-meeting-detail',data)
// 提交会务报名下一步
export const postBaomingSubmit = (data) => request.post('','api/meet/bao-ming/submit-new',data)
// 学习文章详情
export const getStudyDetails = (data) => request.get('','api/learn/learn-detail',data)
// 健康资讯详情
export const getAiHeadLineDetails = (data) => request.get('','api/information/detail',data)
// 健康头条详情
export const getHealthDetails = (data) => request.get('','api/news-show/detail',data)
// 健康资讯点赞
export const getAiHeadLineLike = (data) => request.get('','api/information/set-like',data)
// 评价商品详情
export const getOrdercommitPreview = (data) => request.get('','api/order/comment-preview',data)
// 提交商品详情
export const postOrderComment = (data) => request.post('','api/order/comment',data)
// 订单售后详情
export const getorderRefundDetail = (data) => request.get('','api/order/refund-preview',data)
// 地址获取
export const getAreaList = (data) => request.get('','api/default/area-street-list',data)
// 获取用户信息
export const getUserInfo = (data) => request.get('','api/store-apply/userinfo',data)
// 邀请用户信息提交
export const postAgentBaoming = (data) => request.post('','api/meet/bao-ming/agent-baoming-set',data)
// 用户协商历史
export const getRefundLog = (data) => request.get('','api/order/refund-log',data)
// 订单信息
export const getOrderDetails = (data) => request.get('','api/order/detail',data)
export const getStoreApllyInfo = (data) => request.post('','api/store-apply/get-store-apply-info',data)
// 提交供货商申请
export const postSupplierSave = (data) => request.post('','api/supplier-apply/save',data)
// 供货商申请详情
export const getSupplierDetail = (data) => request.get('','api/supplier-apply/read',data)
// 会务报名信息获取
export const getMeetDetail = (data) => request.get('','api/meet/bao-ming/get-my-meeting-detail',data)
// 获取工单机型
export const getDeviceRepair = (data) => request.post('','api/device_repair/order/form-config',data)
// 千年学院详情
export const getSchoolDetail = (data) => request.get('','api/school/detail',data)
// 获取设备报修服务地址
export const postDeviceProvince = (data) => request.post('','api/device_repair/order/get-province',data)
// 提交设备报修表单
export const postdeviceCreateOrder = (data) => request.post('','api/device_repair/order/create-order',data)
// 上传文件
export const postUploadFile = (data) => request.postTest('','upload/upload-file',data)
// 获取modeule_id
export const getModuleConfig = (data) => request.post('','ysxapp/module-config',data)
// 获取门店详情
export const getStoreDetail = (data) => request.get('','api/store-apply/detail',data)
// 门店申请驳回
export const postStoreCheck = (data) => request.post('','api/store-apply/store-apply-check',data)
// 获取通用配置
export const getGeneralConfig = (data) => request.get('','api/general-config/get-general-config',data)
// 获取培训课程
export const getTrainIndex = (data) => request.get('','api/train/detail',data)
// 获取用户个人信息
export const getUserInfoIndex = (data) => request.get('','api/user/index',data)

// 上传资质
export const postUpService = (data) => request.post('','api/user/ability-save',data)

// 获取资质
export const getQualifications = (data) => request.post('','api/user/ability-detail',data)

// 获取中奖记录详情
export const getPrize= (data) => request.get('','api/luckdraw/detail',data)

// 获取中奖记录 验证码
export const getPrizeCode= (data) => request.get('','api/luckdraw/sendsms',data)

// 提交中奖记录 资料
export const getPrizeSave= (data) => request.get('','api/luckdraw/address-save',data)

// 获取隐私政策协议/服务协议 (同一接口 取的字段不一样)
export const getConfig= (data) => request.get('','api/default/config',data)

// 领取年会优惠券
export const getReceiveCoupon = (data) => request.post('','api/fa-coupon/receive-coupon',data)

// 获取年会优惠券领取状态
export const getCouponStatus = (data) => request.get('','api/fa-coupon/get-coupon-status',data)


// 会议详情H5页面图片资源接口
export const getSolutionImages = (data) => request.get('','api/meet/new-meeting-h5/get-solution-images',data)

// 会议详情H5页面信息资源接口
export const getSolution = (data) => request.get('','api/meet/new-meeting-h5/get-solution',data)

// 获取微信js授权
export const getWxjsConfig = (data) => request.post('','api/meet/bao-ming/jssdk-config',data)

// 千年学院\学习专区\营销专区 视频进度记录
export const setVodeRead = (data) => request.get('','api/content/read',data)

// 登陆/注册
export const apiLogin = (data) => request.post('','api/passport/login-app',data)

// 重置密码
export const resetPwd = (data) => request.post('','api/user/reset-pwd',data)

// 获取验证码
export const getCode = (data) => request.get('','api/user/user-hand-binding',data)

// 会务列表
export const getMeetingList = (data) => request.get('','api/meet/bao-ming/get-meeting-list',data)

// 会务类型
export const getMeetType = (data) => request.get('','api/meet/bao-ming/get-meet-type',data)

// 我的会议
export const getMyMeet = (data) => request.get('','api/meet/bao-ming/get-my-meet',data)

// 讲师简介
export const getTeacherInfo = (data) => request.get('','api/meet/bao-ming/get-meet-lecturer-detail',data)

// 讲师简介
export const getReback = (data) => request.get('','api/meet/bao-ming/re-user',data)
